import { gql } from "@apollo/client";

export const PROCESSES = gql`
  query Processes(
    $where: ProcessWhereInput
    $isIn: JSONObject
    $take: Int
    $skip: Int
    $like: ProcessWhereInput
    $orderBy: [JSONObject]
  ) {
    processes(
      where: $where
      take: $take
      skip: $skip
      like: $like
      orderBy: $orderBy
      isIn: $isIn
    ) {
      data {
        id
        name
        description
        type
        theme
        processStatuses {
          id
          name
          tag
          template
          progress
          order
          color
          background
          moveToNext
          possibleStatuses {
            id
            nextStatus
            conditions {
              id
              operation
              rightOperand
              leftOperand
            }
          }
        }
      }
      count
    }
  }
`;

export const PROCESS = gql`
  query Process($where: ProcessWhereInput) {
    process(where: $where) {
      id
      name
      type
      description
      theme
      additionalInfo
      screenProjectId
      ownedBy {
        id
      }
      insurancePlans {
        id
      }
      config {
        id
        type
        value
      }
      processStatuses {
        id
        name
        tag
        template
        progress
        order
        color
        background
        moveToNext
        nodeType
        config
        formDefinition
        position
        entryConnectors
        outputConnectors
        dataBindings
        possibleStatuses {
          id
          order
          nextStatus
          kind
          event
          delaySeconds
          conditions {
            id
            operation
            rightOperand
            leftOperand
          }
        }
        actions {
          id
          type
          args
          conditions {
            id
            operation
            rightOperand
            leftOperand
          }
        }
        screens {
          id
          currentPublishedVersion {
            id
            versionNumber
            status
            previewImageBase64
            htmlContent
            styleContent
            bindingManifest {
              id
              slots
              report
            }
            translationTable {
              id
              entries
            }
            states {
              id
              name
              order
              htmlContent
              conditions
              bindingManifest {
                id
                slots
                report
              }
            }
          }
          versions {
            id
            versionNumber
            status
            htmlContent
            styleContent
            bindingManifest {
              id
              slots
              report
            }
            states {
              id
              name
              order
              htmlContent
              conditions
              bindingManifest {
                id
                slots
                report
              }
            }
          }
        }
      }
      skills {
        id
        type
        value
      }
    }
  }
`;

const processes = { PROCESSES, PROCESS };

export default processes;
